import {
  FC,
  KeyboardEvent,
  MouseEvent,
  useMemo,
} from 'react';
import cn from 'classnames';
import { v4 as uuid } from 'uuid';

import { DataButton } from 'components/Shared/SharedComponents';
import classes from 'src/styles/_commonClasses.module.scss';
import { Link, Text } from 'src/__generated__/graphqlTypes';
import Icon from 'src/shared/ui/Icon';

import styles from './styles.module.scss';
import { Hint } from './Hint';

import { HeartImageInterface } from '../config/declarations';
import { getHeartImageProps } from '../lib';
import { useHeartImageData } from '../lib/hooks';

const HeartImage: FC<HeartImageInterface> = ({
  psychic,
  className,
  hintClassName,
  assetClassName,
  assetFavoriteClassName,
  contentfulData,
  onClick,
}) => {
  const {
    isFavorite,
    isAddToFavoriteHintActive,
    isAuthenticated,
    onClick: hooksOnClick,
  } = useHeartImageData(psychic);
  const localOnClick = (e: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => {
    onClick?.(e);
    hooksOnClick();
  };
  const tooltipId = useMemo(() => uuid(), []);
  const favoritePsychicCollection = contentfulData.favoritePsychicCollection
    ?.items as Array<Link | Text>;

  const favoritePsychicStyles = (!isFavorite)
    ? cn(assetClassName, styles.asset)
    : cn(assetFavoriteClassName, styles.assetFavorite);
  const isRemove = isAuthenticated && !isFavorite;
  const { button, hint } = getHeartImageProps(favoritePsychicCollection, isRemove);

  if (!button) {
    return null;
  }

  const { image } = button;
  const buttonClasses = cn(classes.cursorPointer, styles.heartImg, className);

  return (
    <>
      <DataButton
        link={button}
        className={buttonClasses}
        data-tooltip-id={tooltipId}
        onClick={localOnClick}
        onKeyPress={localOnClick}
      >
        <Icon
          image={image}
          className={favoritePsychicStyles}
        />
        <Hint
          hint={hint}
          tooltipId={tooltipId}
          isAddToFavoriteHintActive={isAddToFavoriteHintActive}
          className={hintClassName}
        />
      </DataButton>
    </>
  );
};

export default HeartImage;
